import { render, staticRenderFns } from "./DrinkingTabs.vue?vue&type=template&id=e7f265e8&"
import script from "./DrinkingTabs.vue?vue&type=script&lang=ts&"
export * from "./DrinkingTabs.vue?vue&type=script&lang=ts&"
import style0 from "./DrinkingTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports